import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { GetEndpointsRequest, GetEndpointsResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';
export class EndpointFilterBaseDataProvider extends BaseWebComponentDataProvider {
  async getEndpoints(request: GetEndpointsRequest): Promise<GetEndpointsResponse | undefined> {
    throw new Error('Needs to be implemented');
  }
}
